import init from '../../helpers/init';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  $('.js-support-form').on('submit', (e: JQuery.SubmitEvent) => {
    e.preventDefault();
    $('.js-error-support-captcha').hide();
    let form = $(e.currentTarget);
    let data = {
      'name': form.find('input[name=name]').val(),
      'topic': form.find('input[name=topic]').val(),
      'email': form.find('input[name=email]').val(),
      'message': form.find('textarea[name=message]').val(),
      'g-recaptcha-response': form.find('[name=g-recaptcha-response]').val(),
    };
    BX.ajax.runComponentAction('pwd:exhibition.support', 'add', {
      mode: 'class',
      data: data,
    }).then((result: any) => {
      if (result.data) {
        $('.js-support-modal').modal('show');
      } else if (result.data === 0) {
        $('.js-error-support-captcha').show();
      }
    })
      .catch((err: any) => console.log(err));
  });

  $('.js-close-support-modal').on('click', () => {
    $('.js-support-modal').modal('hide');
  });
});
